export const extD = 'externalData';
export const externalDataAssign = 'externalDataAssign';
